<template>
    <section class="content">
        <div class="container-fluid">
            <div class="block-header">
                <h2>{{ nama }}</h2>
            </div>
            <div class="row clearfix">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="card">
                        <div class="header">
                            <h2>
                                List {{ nama }}
                            </h2>
                            <ul class="header-dropdown m-r--5 m-t--10">
                                <router-link v-bind:to="'/main/unduh/' + link + '/tambah'" type="button" class="btn btn-primary waves-effect" v-waves.button>
                                    <i class="material-icons" style="color: #fff;">add_box</i>
                                    <span>Tambah</span>
                                </router-link>
                            </ul>
                        </div>
                        <div class="body">
                                <div id="DataTables_Table_0_wrapper" class="dataTables_wrapper form-inline dt-bootstrap">
                                    <div class="row"><div class="col-sm-6"><div class="dataTables_length" id="DataTables_Table_0_length"><label>Show <select name="DataTables_Table_0_length" v-model="perPage" aria-controls="DataTables_Table_0" class="form-control input-sm"><option value="10">10</option><option value="25">25</option><option value="50">50</option><option value="100">100</option></select> entries</label></div></div><div class="col-sm-6"><div id="DataTables_Table_0_filter" class="dataTables_filter"><label>Search:<input v-model="search" type="search" class="form-control input-sm" placeholder="" aria-controls="DataTables_Table_0"></label></div></div></div>
                                    <table class="table table-bordered table-striped table-hover js-basic-example dataTable">
                                        <thead>
                                        <tr>
                                            <th>No.</th>
                                            <th>Judul</th>
                                            <th>Jenis Regulasi</th>
                                            <th>Bidang</th>
                                            <th>File</th>
                                            <th>Tags</th>
                                            <th>Berlaku Sampai</th>
                                            <th>Aksi</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-if="isLoading">
                                                <td colspan="7" class="text-center"><i class="fa fa-spin fa-spinner"></i> Loading data...</td>
                                            </tr>
                                            <tr v-if="list == ''">
                                                <td colspan="7" class="text-center">Data tidak ditemukan</td>
                                            </tr>
                                            <tr v-if="!isLoading" v-for="(item, index) in list">
                                                <td>{{ ++index + ((currentPage-1)*perPage) }}</td>
                                                <td>{{ item.judul }}</td>
                                                <td>{{ item.jenisRegulasi }}</td>
                                                <td>{{ item.bidang }}</td>
                                                <td><a target="_blank" v-if="item.file != null" v-bind:href="item.file" class="btn btn-info"><i class="fa fa-paperclip"></i> File</a></td>
                                                <td>{{ stripTags(item.tags) }}</td>
                                                <td>{{ item.tglBerlaku }}</td>
                                                <td>
                                                    <button @click="$router.push('/main/unduh/' + link + '/edit/' + item.id_regulasi_dana_pensiun)" style="padding: 4px 8px;" type="button" class="btn bg-green waves-effect">
                                                        <i class="material-icons">create</i>
                                                    </button>
                                                    <button @click="confirmDelete(item.id_regulasi_dana_pensiun)" style="padding: 4px 8px;" type="button" class="btn btn-danger waves-effect">
                                                        <i class="material-icons">delete</i>
                                                    </button>
                                                    <button @click="moveUp(index)" v-if="index != 1" style="padding: 4px 8px;" type="button" class="btn btn-primary waves-effect">
                                                        <i class="fa fa-chevron-up"></i>
                                                    </button>
                                                    <button @click="moveDown(index)" v-if="index !== (list.length)" style="padding: 4px 8px;" type="button" class="btn btn-primary waves-effect">
                                                        <i class="fa fa-chevron-down"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <pagination :total-rows="result.totalElements" :per-page="result.size" v-model="currentPage"></pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
  import api from '@/helper/api'
  import qs from 'qs'
  import Vue from 'vue'
  import FormLine from '../../../components/FormLine.vue'

  export default {
    components: {FormLine},
    name: 'ListVisiMisi',
    data: function () {
      return {
        result: {},
        list: [],
        currentPage: 1,
        perPage: 10,
        search: '',
        modal: null,
        isLoading: true,
        link: '',
        tipe: '',
        nama: ''
      }
    },
    methods: {
      moveUp (index) {
        let a = this.list[index - 1]
        Vue.set(this.list, index - 1, this.list[index - 2])
        Vue.set(this.list, index - 2, a)

        this.saveUrutan()
      },
      moveDown (index) {
        let a = this.list[index - 1]
        Vue.set(this.list, index - 1, this.list[index])
        Vue.set(this.list, index, a)

        this.saveUrutan()
      },
      saveUrutan () {
        let data = []
        for (var i = 0; i < this.list.length; i++) {
          data.push({
            'id': this.list[i].id_regulasi_dana_pensiun,
            'urutan': i,
            'tipe': this.tipe
          })
        }

        api.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token')
        api.post('/regulasi/move', data).then((result) => {
          this.$toastr.s('Urutan berhasil diubah.')
        }).catch((ex) => {
          this.$toastr.e('Gagal mengubah urutan, terjadi kesalahan pada server.')
        })
      },
      getData () {
        var params = []
        params.search = this.search
        params.page = this.currentPage - 1
        params.size = this.perPage

        this.isLoading = true

        api.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token')
        api.get('/' + this.link + '?' + qs.stringify(params)).then((result) => {
          this.result = result.data
          this.list = result.data.content
          this.isLoading = false
        }).catch((ex) => {
          this.isLoading = false
        })
      },
      confirmDelete (id) {
        this.$swal({
          title: 'Konfirmasi',
          text: 'Anda yakin ingin menghapus data ini?',
          icon: 'warning',
          buttons: [
            true, {
              text: 'Ok',
              closeModal: false
            }
          ],
          dangerMode: true
        }).then(result => {
          if (result) this.delete(id)
        })
      },
      delete (id) {
        api.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token')
        api.delete('/' + this.link + '/' + id).then((result) => {
          if (result.data.code === 200) this.$toastr.s('Data berhasil dihapus.')
          else this.$toastr.e('Gagal menghapus data, terjadi kesalahan pada server.')
          this.$swal.close()
          this.getData()
        }).catch((e) => {
          this.$toastr.e('Gagal menghapus data, terjadi kesalahan pada server.')
          this.$swal.close()
        })
      },
      checkRoute (route) {
        this.list = []
        if (route.name === 'ListRegulasi') {
          this.link = 'regulasi'
          this.nama = 'Regulasi'
        }
      }
    },
    mounted: function () {
      this.checkRoute(this.$route)
      this.getData()
    },
    watch: {
      currentPage (e) {
        this.getData()
      },
      perPage (e) {
        this.getData()
      },
      search (e) {
        this.getData()
      },
      '$route' (to, from) {
        this.checkRoute(to)
        this.getData()
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/view/Unduh/Regulasi/ListRegulasi.vue?4d0814c8